import React, { useState } from 'react';
import {getHeightColor} from './HeightLegend';

const Target = (props) => {
  const [show, setShow] = useState(false);

  const M_TO_PX = props.M_TO_PX;
  const totalWidth = (props.xMax - props.xMin) * M_TO_PX;
  const totalHeight = (props.yMax - props.yMin) * M_TO_PX;
  const xPosM = props.target.xPosCm / 100;
  const yPosM = props.target.yPosCm / 100;
  const zPosCm = props.target.zPosCm;
  const isCeiling = props.isCeiling;
  const yShift = props.yShift;
  const yShiftMargin = props.yShiftMargin;
  const xShift = props.xShift
  const cx = isCeiling ? parseFloat(xPosM * M_TO_PX) + (totalWidth / 2) - props.marginLeft
                       : parseFloat((-xPosM + xShift) * M_TO_PX) + (totalWidth / 2) - props.marginLeft;
  const cy = isCeiling ? -parseFloat(((yPosM + 2*yShiftMargin - yShift) * M_TO_PX) - props.marginTop) + (totalHeight / 2)
                       : parseFloat(yPosM * M_TO_PX);
  const topTargetDataCeiling = (yPosM >= (props.yMin - yShift + 0.5)) ? cy + 15 : cy - 39;
  const leftTargetDataCeiling = (xPosM <= (props.xMax - 1)) ? cx + 10 : cx - 120;
  const topTargetDataWall = cy + 15;
  const leftTargetDataWall = (xPosM >= (props.xMin + 1)) ? cx + 10 : cx - 120;

  // console.log(props.target)

  return (
    <>
      <svg
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
          zIndex: 2,
        }}
        width={totalWidth}
        height={totalHeight}
        viewBox={`0 0 ${totalWidth} ${totalHeight}`}
      >
        <circle
          cx={cx}
          cy={cy}
          r={25}
          fill={getHeightColor(zPosCm)}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          style={{ pointerEvents: 'all', cursor: 'pointer' }}
        />
        <text
          x={cx}
          y={cy}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="white"
          fontSize="16"
          style={{ pointerEvents: 'none' }}
        >
          {props.target.id}
        </text>
      </svg>

      {show && (
        <div
          style={{
            position: 'absolute',
            top: isCeiling ? topTargetDataCeiling : topTargetDataWall,
            left: isCeiling ? leftTargetDataCeiling : leftTargetDataWall,
            width: '120px',
            height: '24px',
            backgroundColor: 'gray',
            color: 'white',
            fontSize: '0.85em',
            borderRadius: '12px',
            textAlign: 'center',
            lineHeight: '24px',
            zIndex: 5,
            pointerEvents: 'none',
          }}
        >
          X: {props.target.xPosCm}, Y: {props.target.yPosCm}, Z: {props.target.zPosCm}
        </div>
      )}
    </>
  );
};

export default Target;
